<template>
  <button
    v-tooltip="{
      trigger,
      content: content,
      offset: 5,
      placement: 'right',
      container,
    }"
    :class="{
      'border-theme text-theme hover:opacity-70': themed,
      'border-grey-darker text-grey-darker hover:text-black hover:border-black': !themed,
    }"
    class="flex-shrink-0 inline-flex items-center justify-center w-4 h-4 border rounded-full cursor-pointer transition duration-300 focus:outline-none focus:opacity-40 leading-none"
    @click.prevent
  >
    <span class="text-xxxs font-semibold">?</span>
    <span class="sr-only">Info</span>
  </button>
</template>

<script>
import { isMobile } from "mobile-device-detect";

export default {
  name: "ButtonInfo",
  props: {
    heading: {
      type: String,
      default: "Info Heading",
    },
    body: {
      type: String,
      default: "Info Body",
    },
    themed: {
      type: Boolean,
      default: false,
    },
    container: {
      type: String,
      default: "#app",
    },
  },
  data() {
    return {
      content: `
        <div class="uppercase text-xxs">
          <h4 class="font-semibold mb-1">${this.heading}</h4>
          <p>${this.body}</p>
        </div>
      `,
      trigger: isMobile ? "click" : "hover click",
    };
  },
};
</script>
